@if (account!=null && loaded()) {
<div class="f13 mb-10">
    @if (rewriteEstimationMode() && currentYear==yearEnd) {
    In order to provide you with savings customized to your usage profile, please confirm or update the most recent 12 months of consumption data. Otherwise, forecasted savings will be based upon your utility rate class average usage profile.
    }
    @if (rewriteEstimationMode() && currentYear!=yearEnd) {
    In order to provide you with savings customized to your usage profile, please confirm or update the consumption data from your uploaded {{(yearEnd-1)}}–{{yearEnd}} bill. Otherwise, forecasted savings will be based upon your utility rate class average usage profile.
    }
    @if (!rewriteEstimationMode() && isAIBased) {
    Nonstop Shop ai Levels 2 and 3 require 12 months of consumption history to properly weight the cost benefit of our price plans. If 12 months of consumption history is not available, you can select Nonstop Shop ai Level 1.
    }
    @if (!rewriteEstimationMode() && !isAIBased) {
    In order to provide you with savings customized to your usage profile, please enter the most recent 12 months of consumption data or reasonable estimates. Otherwise, forecasted savings will be based upon your utility rate class average usage profile.
    }
</div>
@if (!emptyConsumptionMode() && !rewriteEstimationMode()) {
Year &nbsp; <select style="display: inline; height: 26px; width: 100px;" (ngModelChange)="selectConsumptionYear($event)" [ngModel]="selectedConsumptionYear">
    @for (y of consumptionYears; track y) {
    <option [value]="y.key">{{y.key+(y.value?" &#10004;":"")}}</option>
    }
</select>
}
@if (currentConsumption.length>0) {
<div>
    @for (i of [0,1,2,3]; track i) {
    <div class="cols">
        @for (j of [0,1,2]; track j) {
        <div class="col equal">
            <input type="text"
                   name="y"
                   [class]="getClassesForInput('consumption_'+months[i*3+j], true, currentConsumption[i*3+j])+showFullnessClass(i*3+j)"
                   (input)="resetError('consumption_'+months[i*3+j]); changeConsumption(i*3+j, currentConsumption[i*3+j])"
                   [placeholder]="months[i*3+j]"
                   [(ngModel)]="currentConsumption[i*3+j]" />
            @if (getVisibilityForLabel(currentConsumption[i*3+j])) {
            <div class="placeholder">{{months[i*3+j]}}</div>
            }
        </div>
        }
    </div>
    }
    @if (notAllDataAvailable()) {
    <div class="error-block">Incomplete Data</div>
    }
</div>
    }
  }